import { addEventSourceErrorBreadcrumb } from "@/shared/lib/observability/network"
import { EventSourcePolyfill } from "event-source-polyfill"

export const createAuthenticatedEventSource = ({
  url,
  token,
  stream,
}: {
  url: string
  token: string
  stream: string
}) => {
  const apiBaseUrl = import.meta.env.VITE_BASE_API_URL
  const eventSourceUrl =
    import.meta.env.DEV && apiBaseUrl && url.startsWith(apiBaseUrl)
      ? url.slice(apiBaseUrl.length)
      : url

  const eventSource = new EventSourcePolyfill(eventSourceUrl, {
    headers: { Authorization: `Bearer ${token}` },
  })

  eventSource.addEventListener("error", (event) => {
    addEventSourceErrorBreadcrumb({
      eventSource,
      event: event as unknown as { status?: number },
      stream,
    })
  })

  return eventSource
}
